import { AfterViewInit, Directive, ElementRef } from '@angular/core';

@Directive({
  selector: '[fitImgInContainer]',
})
export class FitImgInContainerDirective implements AfterViewInit {
  private imgWidth = 0;
  private imgHeight = 0;

  constructor(private el: ElementRef) {
    el.nativeElement.onload = () => {
      this.fitImageInContainer();
    };
  }

  ngAfterViewInit(): void {}

  private fitImageInContainer() {
    const parentContainer = this.el.nativeElement.parentElement;
    this.imgWidth = this.el.nativeElement.offsetWidth;
    this.imgHeight = this.el.nativeElement.offsetHeight;
    const containerWidth = parentContainer.offsetWidth;
    const containerHeight = parentContainer.offsetHeight;

    if (this.imgWidth <= containerWidth && this.imgHeight <= containerHeight) return;

    if (this.imgWidth > containerWidth && this.imgHeight <= containerHeight) {
      const aspectRatio = this.imgHeight / this.imgWidth;
      this.imgHeight = containerWidth * aspectRatio;
      this.imgWidth = containerWidth;
    }

    if (this.imgWidth <= containerWidth && this.imgHeight > containerHeight) {
      const aspectRatio = this.imgWidth / this.imgHeight;
      this.imgHeight = containerHeight;
      this.imgWidth = this.imgHeight * aspectRatio;
    }

    if (this.imgWidth > containerWidth && this.imgHeight > containerHeight) {
      if (this.imgHeight === this.imgWidth) {
        this.imgWidth = this.imgHeight =
          containerWidth < containerHeight ? containerWidth : containerHeight;
      } else {
        const isImgWider = this.imgWidth > this.imgHeight;

        if (isImgWider) {
          const aspectRatio = this.imgHeight / this.imgWidth;
          const tempHeight = containerWidth * aspectRatio;

          if (tempHeight > containerHeight) {
            const aspectRatio = this.imgWidth / this.imgHeight;
            this.imgHeight = containerHeight;
            this.imgWidth = this.imgHeight * aspectRatio;
          } else {
            this.imgHeight = tempHeight;
            this.imgWidth = containerWidth;
          }
        } else {
          const aspectRatio = this.imgWidth / this.imgHeight;
          const tempWidth = containerHeight * aspectRatio;

          if (tempWidth > containerWidth) {
            const aspectRatio = this.imgHeight / this.imgWidth;
            this.imgWidth = containerWidth;
            this.imgHeight = this.imgWidth * aspectRatio;
          } else {
            this.imgWidth = tempWidth;
            this.imgHeight = containerHeight;
          }
        }
      }
    }

    this.el.nativeElement.style.height = this.imgHeight + 'px';
    this.el.nativeElement.style.width = this.imgWidth + 'px';
    this.el.nativeElement.style.transition = 'opacity .5s easy';
  }
}
